/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_FOLLOWUP_AUDIT,
  LOAD_FOLLOWUP_AUDIT_SUCCESS,
  LOAD_FOLLOWUP_AUDIT_ERROR,
  UPDATE_AUDIT_STATUS,
  UPDATE_AUDIT_STATUS_SUCCESS,
  UPDATE_AUDIT_STATUS_ERROR,
  UPDATE_AUDIT_RATING,
  UPDATE_AUDIT_RATING_SUCCESS,
  UPDATE_AUDIT_RATING_ERROR,
  UPDATE_AUDIT_REMARKS,
  UPDATE_AUDIT_REMARKS_SUCCESS,
  UPDATE_AUDIT_REMARKS_ERROR,
  LOAD_FIRST_AUDIT,
  LOAD_FIRST_AUDIT_SUCCESS,
  LOAD_FIRST_AUDIT_ERROR,//FIRST
  LOAD_AUDIT_REMARK,
  LOAD_AUDIT_REMARK_SUCCESS,
  LOAD_AUDIT_REMARK_ERROR,
  LOAD_FOLLOWUP_HISTORY,
  LOAD_FOLLOWUP_HISTORY_SUCCESS,
  LOAD_FOLLOWUP_HISTORY_ERROR,
  ADD_COMPANY_RATING,
  ADD_COMPANY_RATING_SUCCESS,
  ADD_COMPANY_RATING_ERROR,
  ADD_GREEN_FLAG,
  ADD_GREEN_FLAG_SUCCESS,
  ADD_GREEN_FLAG_ERROR,
  ADD_SALE_PYRAMID,
  ADD_SALE_PYRAMID_SUCCESS,
  ADD_SALE_PYRAMID_ERROR
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(auditMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    auditMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}
//Followup Audit list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadFollowupAudit(searchvalue) {
  return {
    type: LOAD_FOLLOWUP_AUDIT,
    searchvalue,
  }
}

export function loadFollowupAuditSuccess(followup_audit) {
  return {
    type: LOAD_FOLLOWUP_AUDIT_SUCCESS,
    followup_audit,
  }
}

/**
 * @param {string} error
 */

export function loadFollowupAuditError(error) {
  return {
    type: LOAD_FOLLOWUP_AUDIT_ERROR,
    error,
  }
}

//Followup Audit Status update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateAuditStatus(auditStatus) {
  return {
    type: UPDATE_AUDIT_STATUS,
    auditStatus,
  }
}

export function updateAuditStatusSuccess(auditStatus, success) {
  return {
    type: UPDATE_AUDIT_STATUS_SUCCESS,
    auditStatus,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateAuditStatusError(error) {
  return {
    type: UPDATE_AUDIT_STATUS_ERROR,
    error,
  }
}

//Followup Audit Rating update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateAuditRating(auditRating) {
  return {
    type: UPDATE_AUDIT_RATING,
    auditRating,
  }
}

export function updateAuditRatingSuccess(auditRating, success) {
  return {
    type: UPDATE_AUDIT_RATING_SUCCESS,
    auditRating,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateAuditRatingError(error) {
  return {
    type: UPDATE_AUDIT_RATING_ERROR,
    error,
  }
}
//Followup Audit Remarks update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateAuditRemarks(auditRemarks) {
  return {
    type: UPDATE_AUDIT_REMARKS,
    auditRemarks,
  }
}

export function updateAuditRemarksSuccess(auditRemarks, success) {
  return {
    type: UPDATE_AUDIT_REMARKS_SUCCESS,
    auditRemarks,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateAuditRemarksError(error) {
  return {
    type: UPDATE_AUDIT_REMARKS_ERROR,
    error,
  }
}
//first FIRST
export function loadfirstAudit(searchvalue) {
  return {
    type: LOAD_FIRST_AUDIT,
    searchvalue,
  }
}

export function loadfirstAuditSuccess(first_audit) {
  return {
    type: LOAD_FIRST_AUDIT_SUCCESS,
    first_audit,
  }
}

/**
 * @param {string} error
 */

export function loadfirstAuditError(error) {
  return {
    type: LOAD_FIRST_AUDIT_ERROR,
    error,
  }
}
export function loadAuditRemark(searchvalue) {
  return {
    type: LOAD_AUDIT_REMARK,
    searchvalue,
  }
}

export function loadAuditRemarkSuccess(auditRemarksDetails) {
  return {
    type: LOAD_AUDIT_REMARK_SUCCESS,
    auditRemarksDetails,
  }
}

/**
 * @param {string} error
 */

export function loadAuditRemarkError(error) {
  return {
    type: LOAD_AUDIT_REMARK_ERROR,
    error,
  }
}
//loadFollowupHistory
export function loadFollowupHistory(searchvalue) {
  return {
    type: LOAD_FOLLOWUP_HISTORY,
    searchvalue,
  }
}

export function loadFollowupHistorySuccess(followup_history) {
  return {
    type: LOAD_FOLLOWUP_HISTORY_SUCCESS,
    followup_history,
  }
}

export function loadFollowupHistoryError(error) {
  return {
    type: LOAD_FOLLOWUP_HISTORY_ERROR,
    error,
  }
}
//addCompanyRating
export function addCompanyRating(companyDetails) {
  return {
    type: ADD_COMPANY_RATING,
    companyDetails,
  }
}

export function addCompanyRatingSuccess(auditStatus, success) {
  return {
    type: ADD_COMPANY_RATING_SUCCESS,
    auditStatus,
    success,
  }
}

export function addCompanyRatingError(error) {
  return {
    type: ADD_COMPANY_RATING_ERROR,
    error,
  }
}

export function addFlag(flagDetails) {
  return {
    type: ADD_GREEN_FLAG,
    flagDetails,
  }
}

export function addFlagSuccess(auditStatus, success) {
  return {
    type: ADD_GREEN_FLAG_SUCCESS,
    auditStatus,
    success,
  }
}
//addFlag
export function addFlagError(error) {
  return {
    type: ADD_GREEN_FLAG_ERROR,
    error,
  }
}


export function addSalePyramid(saleDetails) {
  return {
    type: ADD_SALE_PYRAMID,
    saleDetails,
  }
}

export function addSalePyramidSuccess(auditStatus, success) {
  return {
    type: ADD_SALE_PYRAMID_SUCCESS,
    auditStatus,
    success,
  }
}
//addSalePyramid
export function addSalePyramidError(error) {
  return {
    type: ADD_SALE_PYRAMID_ERROR,
    error,
  }
}
const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  loadFollowupAudit,
  loadFollowupAuditSuccess,
  loadFollowupAuditError,
  updateAuditRemarks,
  updateAuditRemarksSuccess,
  updateAuditRemarksError,
  updateAuditRating,
  updateAuditRatingSuccess,
  updateAuditRatingError,
  updateAuditStatus,
  updateAuditStatusSuccess,
  updateAuditStatusError,

  loadfirstAudit,
  loadfirstAuditError,
  loadfirstAuditSuccess,
  loadAuditRemark,
  loadAuditRemarkSuccess,
  loadAuditRemarkError,
  loadFollowupHistory,
  loadFollowupHistorySuccess,
  loadFollowupHistoryError,
  addCompanyRating,
  addCompanyRatingSuccess,
  addCompanyRatingError,
  addFlag,
  addFlagSuccess,
  addFlagError,
  addSalePyramid,
  addSalePyramidSuccess,
  addSalePyramidError
}

export default actions
